import {
    FilterWrapper,
    StyledDropdownWithLabel
} from './SearchInitiationMobile.styles';

const beds = ['', '0', '1', '2', '3', '4', '5', '6', '7', '8', '9', '10'];

const bedsOptions = [
    { value: '0', text: 'Studio' },
    { value: '1', text: '1' },
    { value: '2', text: '2' },
    { value: '3', text: '3' },
    { value: '4', text: '4' },
    { value: '5', text: '5' },
    { value: '6', text: '6' },
    { value: '7', text: '7' },
    { value: '8', text: '8' },
    { value: '9', text: '9' },
    { value: '10', text: '10+' }
];

export type BedsMin = typeof beds[number];

type SelectBedsToRentProps = {
    value: BedsMin;
    onChange: (bedsMin: BedsMin) => void;
};

export const SelectBedsToRent = ({
    value,
    onChange
}: SelectBedsToRentProps) => {
    const bedsMinOptions = bedsOptions;

    const minBedsLabel = 'Min beds';

    return (
        <FilterWrapper>
            <StyledDropdownWithLabel
                id="mobile_beds_min"
                onChange={(e) => {
                    onChange(e.target.value);
                }}
                value={value}
                name="beds_min"
                aria-label="Min Beds"
                data-testid="min_beds_mobile"
                label={minBedsLabel}
                hasBorderRadius
            >
                <option value="">No min</option>
                {bedsMinOptions.map((bedsMinOption, index) => {
                    return (
                        <option
                            value={bedsMinOption.value}
                            key={`mobile_beds_mins_${index}`}
                        >
                            {bedsMinOption.text}
                        </option>
                    );
                })}
            </StyledDropdownWithLabel>
        </FilterWrapper>
    );
};
